import axiosInstance from "../config/axios.js"

const API_BASE = "/tank-cleaning-files"

const tankCleaningFileCabinetService = {
  // Upload single or multiple files
  uploadFiles: async (tankCleaningId, clientId, files) => {
    const formData = new FormData()
    formData.append("tank_cleaning_id", tankCleaningId)
    formData.append("client_id", clientId)

    files.forEach((file) => {
      formData.append("files", file)
    })

    const response = await axiosInstance.post(API_BASE, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    return response.data
  },

  // Get all files for a tank cleaning
  getFilesByTankCleaning: async (tankCleaningId) => {
    const response = await axiosInstance.get(API_BASE, {
      params: { tank_cleaning_id: tankCleaningId },
    })
    return response.data
  },

  // Get a specific file by ID
  getFileById: async (fileId) => {
    const response = await axiosInstance.get(`${API_BASE}/${fileId}`)
    return response.data
  },

  // Delete a single file
  deleteFile: async (fileId) => {
    const response = await axiosInstance.delete(`${API_BASE}/${fileId}`)
    return response.data
  },

  // Delete multiple files
  deleteMultipleFiles: async (fileIds) => {
    const response = await axiosInstance.delete(`${API_BASE}/delete-multiple`, {
      data: { file_ids: fileIds },
    })
    return response.data
  },

  // Download a single file
  downloadFile: async (fileId) => {
    const response = await axiosInstance.get(`${API_BASE}/${fileId}/download`, {
      responseType: "blob",
    })
    return response.data
  },

  // Download multiple files as ZIP
  downloadMultipleFiles: async (fileIds) => {
    const response = await axiosInstance.get(`${API_BASE}/download-multiple`, {
      params: { file_ids: fileIds },
      responseType: "blob",
    })
    return response.data
  },

  // Download all files for a tank cleaning
  downloadByTankCleaning: async (tankCleaningId) => {
    const response = await axiosInstance.get(`${API_BASE}/download-by-tank-cleaning`, {
      params: { tank_cleaning_id: tankCleaningId },
      responseType: "blob",
    })
    return response.data
  },

  // Download entire file cabinet
  downloadAllCabinet: async () => {
    const response = await axiosInstance.get(`${API_BASE}/download-all-cabinet`, {
      responseType: "blob",
    })
    return response.data
  },
}

export default tankCleaningFileCabinetService